import { defineComponent as k, computed as g, createElementBlock as t, openBlock as s, createElementVNode as o, Fragment as u, renderList as y, normalizeClass as L, toDisplayString as h, createVNode as c, unref as m, withCtx as x } from "vue";
import { RevLink as v } from "@ds/components/Link";
import w from "../../icons/generated/IconArrowLeft.vue2.js";
import B from "../../icons/generated/IconChevronRight.vue2.js";
import { tw as a } from "../../utils/tailwind.js";
const C = ["aria-label"], N = {
  class: "m-0 flex list-none items-center py-12 md:py-20",
  itemscope: "",
  itemtype: "http://schema.org/BreadcrumbList"
}, $ = {
  key: 0,
  "aria-current": "page",
  class: "body-2 truncate",
  itemprop: "name"
}, E = {
  class: "body-2-bold truncate",
  itemprop: "name"
}, V = ["content"], I = /* @__PURE__ */ k({
  name: "RevBreadcrumbs",
  __name: "Breadcrumbs",
  props: {
    breads: {},
    ariaLabel: {}
  },
  emits: ["click-breadcrumb"],
  setup(l, { emit: b }) {
    const n = l, _ = b, f = g(
      () => n.breads.map((d, i) => {
        const e = i === n.breads.length - 1, r = i === Math.max(n.breads.length - 2, 0), p = [
          a`text-action-default-hi md:flex`,
          e ? a`min-w-[6ch]` : a`md:shrink-0`,
          r ? a`min-w-0` : a`hidden`
        ];
        return { ...d, isLast: e, classNames: p };
      })
    );
    return (d, i) => (s(), t("nav", { "aria-label": l.ariaLabel }, [
      o("ol", N, [
        (s(!0), t(u, null, y(f.value, (e, r) => (s(), t("li", {
          key: e.title,
          class: L(e.classNames),
          itemprop: "itemListElement",
          itemscope: "",
          itemtype: "http://schema.org/ListItem"
        }, [
          e.isLast ? (s(), t("div", $, h(e.title), 1)) : (s(), t(u, { key: 1 }, [
            c(m(v), {
              class: "flex items-center whitespace-nowrap",
              itemprop: "item",
              to: e.link,
              tracking: e.tracking,
              underlined: !1,
              onClick: (p) => _("click-breadcrumb", e.title)
            }, {
              default: x(() => [
                c(m(w), { class: "mr-8 shrink-0 md:hidden" }),
                o("span", E, h(e.title), 1)
              ]),
              _: 2
            }, 1032, ["to", "tracking", "onClick"]),
            c(m(B), { class: "hidden md:mx-8 md:block" })
          ], 64)),
          o("meta", {
            content: `${r + 1}`,
            itemprop: "position"
          }, null, 8, V)
        ], 2))), 128))
      ])
    ], 8, C));
  }
});
export {
  I as default
};
